import React, {FC, memo} from 'react';
import {useIsRealUserModeEnabled} from '@aboutyou/bootstrap/client';
import {useInView} from '@aboutyou/ui-components';
import {FooterSkeleton} from '@aboutyou/logic-components';
import {useCurrentPageType} from '@aboutyou/router';
import {lazy} from '@aboutyou/lazy-imports';

export const LazyFooter = lazy(
  () =>
    import(
      '@aboutyou/logic-components/src/backend-services/Footer/Footer'
    ).then(mod => ({default: mod.Footer})),
  {
    fallback: <FooterSkeleton />,
  },
);

const FooterConfigured: FC = memo(function Footer() {
  // memo is used as the useCurrentPageType is expensive and should not trigger too often
  const isCheckout = useCurrentPageType() === 'checkout';
  const isRealUserModeEnabled = useIsRealUserModeEnabled();

  return (
    <LazyFooter
      noMargin={isCheckout}
      hideNewsletterForm={isCheckout}
      hideCategories={isCheckout}
      disableRouteUpdates={isRealUserModeEnabled}
      uspItemsToDisplayPerSlide={3}
    />
  );
});

export const Footer = () => {
  const isRealUserModeEnabled = useIsRealUserModeEnabled();
  const {ref, inView} = useInView<HTMLDivElement>({
    threshold: 0,
    rootMargin: '500px',
    triggerOnce: true,
  });

  if (!isRealUserModeEnabled) {
    // if real user mode is not activated, always render the footer on the server
    return <FooterConfigured />;
  }

  return inView ? <FooterConfigured /> : <FooterSkeleton ref={ref} />;
};
